export const directContactFormBuildErrorSubjectLine = ({
  orderId,
  phoneNumber,
  productCode,
  subject,
}: {
  orderId?: string
  phoneNumber: string
  productCode: string
  subject: string
}): string =>
  [subject, productCode, orderId, phoneNumber].filter(Boolean).join(' | ')
